<template lang="pug">
  #CustomerUsersModel.CustomerModel.CustomerModel-usersModel(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2.p-3
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content.p-3
      b-input-group.mb-3
        b-form-input(
          v-model="searchInput",
          placeholder="請輸入關鍵字"
        )
        b-input-group-append
          b-input-group-text
            i.fas.fa-search
          b-button(
            variant="primary",
            size="sm",
            @click="autoSelectHandler()"
          ) 全選/清除
      .mb-2
        b-card.border-0.customerCard.mb-3(
          bg-variant="light",
          v-for="(user,index) in filterUsers",
          :key="user.line_uuid",
          body-class="p-1"
        )
          .row.no-gutters.py-3
            .col-1.d-flex.align-items-center.justify-content-center
              b-form-checkbox(
                :id="`checkbox-group-${index}`",
                v-model="selectUsersId",
                :name="`user-${index}`",
                :value="user.line_uuid"
              )
            .col-11
              label.w-100.mb-0(
                :for="`checkbox-group-${index}`"
              )
                .row.align-items-center.no-gutters
                  .col-3.pr-1
                    ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                      :profileUrl="user.picture_url",
                      :style="{ 'width': '60px', 'height': '60px' }"
                    )
                  .col-9.pl-1
                    .row.no-gutters
                      .col-6
                        small 暱稱名： {{ user.line_display_name }}
                      .col-6
                        small 備註名： {{ user.note_name }}
                      .col-12
                        small ECM ID： 12345678
                      .col-6
                        small.mb-0 客戶TR：
                        b-badge(
                          variant="white",
                          class="rounded-0 p-1 bg-white"
                        ) {{ TRList.includes(user.level) ? user.level : '' }}
                      .col-6
                        small.mb-0 性別：
                        b-badge(
                          variant="white",
                          class="rounded-0 p-1 bg-white"
                        ) {{ genderList.includes(user.gender) ? user.gender : '' }}
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles",
          ref="infiniteLoading"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
      p.mb-3(
        v-if="filterUsers.length === 0"
      ) 無可標籤的客戶
    .row.no-gutters
      .col-6
        b-button(
          variant="light",
          block,
          @click="closeModel()",
          class="rounded-0 text-black border-gray"
        ) 取消
      .col-6
        b-button(
          variant="primary",
          block,
          @click="submitHandler()",
          class="rounded-0 text-black border-gray"
        ) 選擇確認
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';

const _ = require('lodash');

export default {
  name: 'UsersModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      required: true
    }
  },
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      searchInput: null,
      selectUsersId: [],
      infiniteId: +new Date(),
      mode: null
    };
  },
  mounted() {
    this.$EventBus.$on('openUsersModel', (mode) => {
      if (!mode) return;
      this.mode = mode;
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n載入中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectUsersId = [];
      vm.searchInput = null;
      vm.$store.commit(`${vm.role}_label/resetInfiniteLoadingData`);

      // 把原本有選擇的人放進來
      _.forEach(vm.role === 'sm' ? vm.sm_selectUsers : vm.sa_selectUsers, (res) => {
        vm.selectUsersId.push(res.line_uuid);
      });

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      if (!vm.mode) {
          vm.$swal.fire({
          icon: 'error',
          title: '編輯目標錯誤[Err: Not Has NowSelect]'
        });
        return;
      }

      vm.$store.dispatch(`${vm.role}_label/getBackendMemberListHandler`, {
        current_page: vm.role === 'sm' ? vm.sm_pagination.current_page + 1 : vm.sa_pagination.current_page + 1,
        per_page: vm.role === 'sm' ? vm.sm_pagination.per_page : vm.sa_pagination.per_page,
        filter_type: vm.mode
      }).then(() => {
        if ((vm.role === 'sm' ? vm.sm_pagination.current_page : vm.sa_pagination.current_page) !== (vm.role === 'sm' ? vm.sm_pagination.total_page : vm.sa_pagination.total_page)) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.mode = null;
      this.showModel = false;
    },
    autoSelectHandler() {
      const vm = this;
      if (!vm.selectUsersId || vm.selectUsersId.length === 0) {
        _.forEach(vm.role === 'sm' ? vm.sm_memberList : vm.sa_memberList, (user) => {
          vm.selectUsersId.push(user.line_uuid);
        });
      } else vm.selectUsersId = [];
    },
    submitHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n處理中',
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const selectUsersArr = [];

      _.forEach(vm.role === 'sm' ? vm.sm_memberList : vm.sa_memberList, (res) => {
        if (vm.selectUsersId.indexOf(res.line_uuid) !== -1) {
          selectUsersArr.push(res);
        }
      });

      vm.$store.commit(`${vm.role}_label/setSelectUsers`, selectUsersArr);
      vm.$swal.close();
      vm.closeModel();
    }
  },
  computed: {
    ...mapState({
      sa_memberList: (state) => state.sa_label.memberList,
      sa_selectUsers: (state) => state.sa_label.selectUsers,
      sa_pagination: (state) => state.sa_label.pagination,
      sm_memberList: (state) => state.sm_label.memberList,
      sm_selectUsers: (state) => state.sm_label.selectUsers,
      sm_pagination: (state) => state.sm_label.pagination,
      TRList: (state) => state.sa.TRList,
      genderList: (state) => state.sa.genderList,
    }),
    filterUsers() {
      const vm = this;
      if (!vm.searchInput || vm.searchInput === '') {
        return vm.role === 'sm' ? vm.sm_memberList : vm.sa_memberList;
      }
      return vm.role === 'sm' ? vm.sm_memberList : vm.sa_memberList.filter((user) => user.line_display_name.includes(vm.searchInput));
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openUsersModel');
  }
};
</script>

<style>

</style>
